module.exports = __webpack_public_path__ + "static/img/sdl_image.efc1f3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/1x/sdl_image.png
// module id = iWRB
// module chunks = 1